import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import FontAwesomeIcon from "./Icon";
import ToggleButton from "../../PlayerButtons/ToggleButton";
// import Selector from '../Selector/Selector';
import VolumeGreen from "../Innovators/VolumeGreen";
import ProgressGreen from "../Innovators/ProgressGreen";

import { evaluate } from "../../../utilities/props";

const IndustryOfWeekVideo = ({
  episode: { currentepisode },
  time,
  videoduration,
}) => {
  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const playerRef = useRef(null);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);
  // const [, setSubtitle] = useState(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);
  return (
    <Fragment>
      <div className="week-video-container" ref={playerRef}>
        <div
          className={
            showOverlay ? "alt-video-overlay" : "alt-video-overlay-pause"
          }
        >
          <div className="video-info">
            <ul className="video-info-items">
              <li className="video-info-item green">
                {currentepisode && currentepisode.week}
              </li>
              <li className="video-info-item">
                {currentepisode && currentepisode.industrydescriptionname}
              </li>
            </ul>
          </div>
          <div className="alt-left-controls">
            <ul className="controls">
              <li className="control green">
                <i className="fas fa-backward fa-lg"></i>
              </li>
              <li className="control green">
                <i className="fas fa-forward fa-lg"></i>
              </li>
              <VolumeGreen
                className="Rac__volume"
                onChange={(level) => {
                  const volume = level / 100;
                  videoRef.current.volume = volume;
                  videoRef.current.muted = volume === 0;
                }}
              />
            </ul>
          </div>
          <ToggleButton
            className="alt-center-controls"
            value={() => videoRef.current && !videoRef.current.paused}
            onChange={(active) => {
              if (!active) {
                return videoRef.current.pause();
              }

              return videoRef.current.play();
            }}
          >
            {(active) => {
              if (currentTime > 0.1 && currentTime < duration && active) {
                setshowOverlay(true);
                return (
                  <i
                    className="far fa-pause-circle green fa-4x"
                    onClick={(e) => videoRef.current.pause()}
                  ></i>
                );
              } else {
                setshowOverlay(false);
              }
              if (currentTime === duration) {
                setCurrentTime(0);
              } else if (currentTime === 0 && !active) {
                return (
                  <i
                    className="far fa-play-circle green fa-4x"
                    onClick={(e) => videoRef.current.play()}
                  ></i>
                );
              }
              return (
                <i
                  className="far fa-play-circle green fa-4x"
                  onClick={(e) => videoRef.current.play()}
                ></i>
              );
            }}
          </ToggleButton>
          <ProgressGreen
            className="Rac__progress-bar"
            initial={0}
            time={currentTime}
            duration={duration}
            onSkip={(time) => (videoRef.current.currentTime = time)}
          />
          <div className="icon-flex-expand-settings">
            <ToggleButton
              className="Rac__screen-toggle"
              initial={document.fullscreenElement}
              onChange={(active) => {
                if (!active && KeyboardEvent.key === "Escape") {
                  return document.exitFullscreen();
                }

                return playerRef.current.requestFullscreen({
                  navigationUI: "hide",
                });
              }}
            >
              {(active) => {
                if (!active) {
                  return (
                    <FontAwesomeIcon
                      icon="expand"
                      size="lg"
                      className="green"
                    />
                  );
                }

                if (active) {
                  return (
                    <FontAwesomeIcon
                      icon="compress"
                      size="lg"
                      className="green"
                    />
                  );
                }
              }}
            </ToggleButton>
            <ToggleButton className="">
              {(showSettings) => {
                if (showSettings) {
                  return (
                    <div className="relative-button-container">
                      <li className="control green">
                        <i className="fas fa-cog fa-lg icon-padding"></i>
                      </li>
                      <div className="video-settings">
                        <ul className="video-setting">
                          <li className="video-option green bold">Quality</li>
                          <li className="video-option white cursor">
                            Auto
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option green bold">Caption</li>
                          <li className="video-option white cursor">
                            Off
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option green bold">
                            Report Issue
                          </li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option green bold">Advanced</li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  );
                }

                return (
                  <div className="relative-button-container">
                    <li className="control green">
                      <i className="fas fa-cog fa-lg"></i>
                    </li>
                  </div>
                );
              }}
            </ToggleButton>
          </div>
        </div>
        <video
          ref={videoRef}
          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/industry_of_week_videos/${currentepisode.video}`}
          poster={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/industry_of_week_images/${currentepisode.poster}`}
          loop
          className="fill-video"
        ></video>
      </div>
    </Fragment>
  );
};

IndustryOfWeekVideo.propTypes = {
  episode: PropTypes.object.isRequired,
};

export default IndustryOfWeekVideo;
